export enum LeiCategory {
  ISSUER = 'ISSUER',
  GUARANTOR = 'GUARANTOR',
  OFFEROR = 'OFFEROR',
}
